export const getCurrentUserFullName = state =>
  state?.appState?.user?.fullName ?? ''

export const getIsAppLoading = state =>
  state?.appState?.isLoading ?? false

export const getCurrentUserEmail = state =>
  state?.appState?.user?.email ?? ''

export const getCurrentUserId = state =>
  state?.appState?.user?.id ?? ''
